var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var UiSelectSlider = function () {
            function UiSelectSlider(element) {
                _classCallCheck(this, UiSelectSlider);

                this.element = element;
                this.swiper = null;

                if (!this.element || this.element.dataset.uiSelectSliderInitialized === '1' || typeof Swiper === 'undefined') {
                    return;
                }

                this.init();
            }

            _createClass(UiSelectSlider, [{
                key: "init",
                value: function init() {
                    var isDesktop = this.element.classList.contains('ui-select-slider--desktop');

                    if (isDesktop) {
                        this.element.dataset.uiSelectSliderInitialized = '1';
                        return;
                    }

                    this.swiper = new Swiper(this.element, {
                        loop: false,
                        slidesPerView: 'auto',
                        spaceBetween: 6,
                        watchOverflow: true,
                        threshold: 8,
                        touchStartPreventDefault: false,
                        preventClicks: false,
                        preventClicksPropagation: false,
                        pagination: {
                            el: null
                        },
                        navigation: {
                            nextEl: null,
                            prevEl: null
                        }
                    });

                    this.element.dataset.uiSelectSliderInitialized = '1';
                }
            }], [{
                key: "initAll",
                value: function initAll() {
                    var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

                    root.querySelectorAll('.js-ui-select-slider').forEach(function (element) {
                        if (element.dataset.uiSelectSliderInitialized === '1') {
                            return;
                        }

                        element.uiSelectSliderInstance = new UiSelectSlider(element);
                    });
                }
            }]);

            return UiSelectSlider;
        }();

        function initUiSelectSlider() {
            UiSelectSlider.initAll();
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initUiSelectSlider);
        } else {
            initUiSelectSlider();
        }

        window.UiSelectSlider = UiSelectSlider;
        window.initUiSelectSlider = initUiSelectSlider;
    }, {}] }, {}, [1]);